module.exports = __webpack_public_path__ + "static/img/banner-home.96a56f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/government/banner-home.png
// module id = D2Kj
// module chunks = 44